<template>
  <div class="step-description">
    <div v-for="(description, index) in currentDescriptions" :key="index">
      <p class="mb-0">{{ description }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StepDescription',
  props: {
    currentStep: {
      required: true,
    }
  },
  computed: {
    currentDescriptions() {
      return this.descriptions[this.currentStep] ?? [];
    }
  },
  data() {
    return {
      descriptions: {}
    };
  },
  watch: {
    '$route.params.product': 
    {
      handler(val)
      {
        if(val)
        {
          this.descriptions = {};
        }
        else{
          this.descriptions = {
            1: [ this.$t("simulator.step1Title") ],
            2: [ this.$t("simulator.step2Title") ],
            3: [ this.$t("simulator.step3Title") ],
            4: [ this.$t("simulator.step4Title") ],
            5: [ this.$t("simulator.step5Title") ],          
          }        
        }
      },
      deep: true,
      immediate: true 
    }
  },
}
</script>